import { render, staticRenderFns } from "./deptHarmfulFactors.vue?vue&type=template&id=2faf79ab"
import script from "./deptHarmfulFactors.vue?vue&type=script&lang=js"
export * from "./deptHarmfulFactors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2faf79ab')) {
      api.createRecord('2faf79ab', component.options)
    } else {
      api.reload('2faf79ab', component.options)
    }
    module.hot.accept("./deptHarmfulFactors.vue?vue&type=template&id=2faf79ab", function () {
      api.rerender('2faf79ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/wmr/deptHarmfulFactors.vue"
export default component.exports